/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GlobalSearchCommand,
  GlobalSearchResponse,
} from '../models/index';
import {
    GlobalSearchCommandFromJSON,
    GlobalSearchCommandToJSON,
    GlobalSearchResponseFromJSON,
    GlobalSearchResponseToJSON,
} from '../models/index';

export interface GlobalSearchRequest {
    globalSearchCommand: GlobalSearchCommand;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     * Recherche transverse sur les types client, contrat, devis, simulation, note, contratGroupe. Bearer classique, aucune permission spéciale : le back scope selon le rôle actif (courtier = ses dossiers ; Plateforme / portefeuille partagé = toute l\'orga ; admin pur = réponse vide). Moins de 2 caractères utiles (après trim) => groups vide. Les groupes vides sont supprimés et arrivent triés par pertinence métier (client, contrat, devis, simulation, note, contratGroupe) — à afficher dans l\'ordre reçu. Si un type tombe en erreur côté back, il est simplement absent de la réponse. 
     * Recherche globale (barre du header)
     */
    async globalSearchRaw(requestParameters: GlobalSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlobalSearchResponse>> {
        if (requestParameters['globalSearchCommand'] == null) {
            throw new runtime.RequiredError(
                'globalSearchCommand',
                'Required parameter "globalSearchCommand" was null or undefined when calling globalSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/recherche/globale`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalSearchCommandToJSON(requestParameters['globalSearchCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalSearchResponseFromJSON(jsonValue));
    }

    /**
     * Recherche transverse sur les types client, contrat, devis, simulation, note, contratGroupe. Bearer classique, aucune permission spéciale : le back scope selon le rôle actif (courtier = ses dossiers ; Plateforme / portefeuille partagé = toute l\'orga ; admin pur = réponse vide). Moins de 2 caractères utiles (après trim) => groups vide. Les groupes vides sont supprimés et arrivent triés par pertinence métier (client, contrat, devis, simulation, note, contratGroupe) — à afficher dans l\'ordre reçu. Si un type tombe en erreur côté back, il est simplement absent de la réponse. 
     * Recherche globale (barre du header)
     */
    async globalSearch(requestParameters: GlobalSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlobalSearchResponse> {
        const response = await this.globalSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
